import React from 'react'
import { CustomButton } from 'styles/global'
import {
  Bar,
  BarGroup,
  ChartWrapper,
  ComparativoWrapper,
  Label
} from '../style'
import { Col, Row } from 'reactstrap'
import { HashLink } from 'react-router-hash-link'
import { scrollWithOffset } from 'util/scrollWithOffset'

const ComparativoTaxas = () => {
  const rates = [
    {
      label: 'Crédito Consignado',
      value: '1,85%',
      height: '90px',
      color: '#00B050'
    },
    {
      label: 'Antecipação FGTS',
      value: '1,99%',
      height: '97px',
      color: '#00B050'
    },
    {
      label: 'Cartão Consignado',
      value: '2,73%',
      height: '158px',
      color: '#00B050'
    },
    {
      label: 'Crédito Pessoal',
      value: '18%',
      height: '339px',
      color: '#9A9A9A'
    },
    {
      label: 'Cartão crédito convencional',
      value: '19%',
      height: '400px',
      color: '#9A9A9A'
    }
  ]
  return (
    <ComparativoWrapper>
      <div className="container d-flex gap-3">
        <Row className="row-gap-20 flex-wrap">
          <Col
            xs={12}
            xl={6}
            className="d-flex align-items-stretch order-1 order-xl-1"
          >
            <div className="d-flex flex-column justify-content-center gap-0 w-100">
              <div className="container-comparativo">
                <h2>Mais crédito, menos juros. Simples assim.</h2>
                <p>
                  Compare, escolha e economize com taxas que cabem no seu bolso.
                </p>

                <div className="d-none d-xl-flex justify-content-center mt-3">
                  <HashLink
                    to="/#iniciar-simulacao"
                    className="w-100 d-flex justify-content-center no-styled-link"
                    smooth
                    scroll={(el) => {
                      scrollWithOffset(el, 300)
                    }}
                  >
                    <CustomButton
                      className="simulation-button"
                      background="var(--verde-riber)"
                      borderRadius={50}
                      height="56px"
                      fontSize="1.5rem"
                    >
                      Simular
                    </CustomButton>
                  </HashLink>
                </div>
              </div>
            </div>
          </Col>

          <Col xs={12} xl={6} className="order-2 order-xl-2">
            <ChartWrapper className="container">
              {rates.map((item, idx) => (
                <BarGroup key={idx}>
                  <Bar height={item.height} color={item.color}>
                    <span>{item.value}</span>
                  </Bar>
                  <Label>{item.label}</Label>
                </BarGroup>
              ))}
            </ChartWrapper>
          </Col>

          <Col
            xs={12}
            className="d-flex d-xl-none justify-content-center mt-3 order-3"
          >
            <HashLink
              to="/#iniciar-simulacao"
              className="w-100 d-flex justify-content-center no-styled-link"
              smooth
              scroll={(el) => {
                scrollWithOffset(el, 300)
              }}
            >
              <CustomButton
                className="simulation-button"
                background="var(--verde-riber)"
                borderRadius={50}
                height="56px"
                fontSize="1.5rem"
              >
                Simular
              </CustomButton>
            </HashLink>
          </Col>
        </Row>
      </div>
    </ComparativoWrapper>
  )
}

export default ComparativoTaxas
